import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeStyle as _normalizeStyle, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "custom-editable-node" }
const _hoisted_2 = {
  key: 0,
  class: "custom-handle-label"
}
const _hoisted_3 = { class: "comp_output" }
const _hoisted_4 = { style: {"width":"100px","height":"100px"} }

import {
  CSSProperties,
  ref,
  computed,
  watch,
  onMounted,
  onUnmounted,
  inject
} from "vue";
import { Handle, Position, Connection, Edge, NodeProps } from "@braks/vue-flow";
interface ColorSelectorNodeProps extends NodeProps {
  id: string;
  data: {
    orchName: string;
    orchApi: string;
    validity: string;
    runstatus: {
      status: string;
      time: string;
      iterations?: number;
    };
    orchOptions?: object;
    orchParameters?: object;
    orchInputs?: object;
    orchOutputs?: object;
  };
  type: string;
  selected?: boolean;
  connectable?: boolean;
  xPos?: number;
  yPos?: number;
  targetPosition?: Position;
  sourcePosition?: Position;
  dragging?: boolean;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'EditableNode',
  props: {
    id: {},
    data: {},
    type: {},
    selected: { type: Boolean },
    connectable: { type: Boolean },
    xPos: {},
    yPos: {},
    targetPosition: {},
    sourcePosition: {},
    dragging: { type: Boolean },
    isValidTargetPos: { type: Function },
    isValidSourcePos: { type: Function },
    __vf: {},
    position: {},
    class: {},
    style: {},
    isHidden: { type: Boolean },
    draggable: { type: [Object, Boolean] },
    selectable: { type: Boolean },
    dragHandle: {},
    snapGrid: {}
  },
  emits: ["updateHandles"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props;
const targetHandleStyle: CSSProperties = { background: "rgb(66, 66, 66)" };
const offsetInc = (dataObject: object, index: number) =>
  (1 / (Object.keys(dataObject).length + 1)) * 100 * (index + 1);
const currentHandleLabel = ref();
let hoverOverHandle = ref(false);
const results = ref();
let isLoading = false;
let error = null;
let timer;
let showResult = ref(false);
const userAPIEndPoint = inject('back_end_user_services_API_end_point');
const userJWTToken = inject('userJWTToken');

const getHandles = function (data, handles) {
  for (let i = 0; i <= Object.keys(data).length - 1; i++) {
    const name: string = Object.keys(data)[i];

    // parametric data connections have different style
    // const isParam: boolean = data[name] === "implicit";
    const offsetIncVal = offsetInc(data, i);
    handles.push({
      id: name,
      value: name,
      // isParam: isParam,
      style: {
        ...targetHandleStyle,
        top: offsetIncVal.toString() + "%",
      },
      data: { offsetTop: offsetIncVal },
    });
  }
  return handles;
};

const outputHandles = computed(() =>
  props.data.orchOutputs ? getHandles(props.data.orchOutputs, []) : []
);
const inputHandles = computed(() =>
  props.data.orchInputs ? getHandles(props.data.orchInputs, []) : []
);

const setDriver = function (data) {
  if (data !== "{}" && "isDriver" in data) return data["isDriver"];
  return false;
  };
const isDriver = props.data.orchOptions
  ? setDriver(props.data.orchOptions)
  : false;

watch(
  () => [props.data.orchOutputs, props.data.orchInputs],
  (newval, oldval) => {
    console.log("updated handles event triggered for ", props.data.orchName);
    emit("updateHandles", [
      { id: props.id, handles: outputHandles, type: "source" },
      { id: props.id, handles: inputHandles, type: "target" },
    ]);
  }
);

const onConnect = (params: Connection | Edge) =>
  console.log("handle onConnect", params);

const getLabel = (id) => (currentHandleLabel.value = id);
const showLabel = () => (hoverOverHandle.value = true);
const hideLabel = () => (hoverOverHandle.value = false);

const getStatus = async () => {
  isLoading = true;
  error = null;
  console.log("STATUS orch");
  await fetch(userAPIEndPoint + "/status", {
    method: "GET",
    headers: { "Authorization": `Bearer ${userJWTToken.value}` }
    }).then((response) => {
      if (response.ok) {
        return response.json();
      }
    }).then((data) => {
      isLoading = false;
      results.value = data.response;
      console.log(data.response);
      if (props.data.orchName in results.value) {showResult.value = true;}
    }).catch((error) => {
      console.log(error);
      isLoading = false;
      error = "Failed to fetch data - please try again later.";
    });
};
const cancelAutoUpdate = () => clearInterval(timer);

// TODO design better display of node status information
// TODO - status calls are currently repeated for every additional component >> split the api call and results assignment - do the api call in Custom Editable Node and provide outputs to children    
// from the server at regular intervals and fails if the server cna't be reached
onMounted(() => {
  // getStatus();
  // timer = setInterval(getStatus, 10000);
});
onUnmounted(() => cancelAutoUpdate());


return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inputHandles.value, (handle) => {
        return (_openBlock(), _createBlock(_unref(Handle), {
          key: handle.id,
          id: handle.id,
          type: "target",
          position: _unref(Position).Left,
          style: _normalizeStyle(handle.style),
          onMouseover: ($event: any) => (getLabel(handle.id)),
          onMouseenter: showLabel,
          onMouseleave: hideLabel
        }, null, 8, ["id", "position", "style", "onMouseover"]))
      }), 128)),
      _createElementVNode("div", null, [
        _createElementVNode("strong", null, _toDisplayString(props.data.orchName), 1),
        (props.data.validity === 'invalid')
          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
              key: 0,
              icon: "exclamation-circle",
              size: "lg",
              style: {"margin":"5px","color":"red"}
            }))
          : _createCommentVNode("", true),
        (props.data.validity === 'pending')
          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
              key: 1,
              icon: "question-circle",
              size: "lg",
              style: {"margin":"5px","color":"blue"}
            }))
          : _createCommentVNode("", true),
        (props.data.validity === 'valid')
          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
              key: 2,
              icon: "check-circle",
              size: "lg",
              style: {"margin":"5px","color":"green"}
            }))
          : _createCommentVNode("", true)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(outputHandles.value, (handle) => {
        return (_openBlock(), _createBlock(_unref(Handle), {
          key: handle.id,
          id: handle.id,
          type: "source",
          position: _unref(Position).Right,
          style: _normalizeStyle(handle.style),
          onMouseover: ($event: any) => (getLabel(handle.id)),
          onMouseenter: showLabel,
          onMouseleave: hideLabel
        }, null, 8, ["id", "position", "style", "onMouseover"]))
      }), 128))
    ]),
    (_unref(hoverOverHandle))
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(currentHandleLabel.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (props.data.runstatus.status === 'setup')
          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
              key: 0,
              icon: "screwdriver-wrench",
              style: {"margin":"5px"},
              class: "fa-3x"
            }))
          : _createCommentVNode("", true),
        (props.data.runstatus.status === 'compute')
          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
              key: 1,
              icon: "gear",
              style: {"margin":"5px","--fa-animation-duration":"3s"},
              class: "fa-3x fa-spin"
            }))
          : _createCommentVNode("", true),
        (props.data.runstatus.status === 'error')
          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
              key: 2,
              icon: "exclamation-triangle",
              style: {"margin":"5px"},
              class: "fa-3x fa-fade"
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('message.Last_event')) + " @ " + _toDisplayString(props.data.runstatus.time), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('message.Current_iteration')) + " # " + _toDisplayString(props.data.runstatus.iterations), 1)
    ])
  ]))
}
}

})